import { useState, useEffect, useRef } from "react";
import Alert from "../components/ui/Alert";
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardMedia, Skeleton } from "@mui/material";
import { useData } from "../context/dataContext";
import ButtonInternet from "../components/ui/ButtonInternet";


const Paneles = () => {
    const { user, dataFirebase, loadData, checkAllInternetConnections } = useData()
    const executedRef = useRef(false);
    const [alert, setAlert] = useState('')
    const navigate = useNavigate();

    useEffect(() => {
        if (!executedRef.current && dataFirebase && Object.keys(dataFirebase).length > 0) {
            executedRef.current = true; // marca como ejecutado
            checkAllInternetConnections(dataFirebase);
        }
    }, [dataFirebase]);

    const items = dataFirebase ? Object.values(dataFirebase) : [];
    const lastTwo = items.length >= 4 ? items.slice(-2) : [];
    const rest = items.length >= 4 ? items.slice(0, -2) : items;
    // console.log(user)
    // console.log(user.Maintenance)
    return (
        <>
            {!loadData ? (
                <>
                    {alert !== '' && <Alert stateAlert={alert} closeAlert={() => { setAlert('') }} />}
                    <div className={`w-full h-full flex flex-col gap-8 bg-[#f9f9f9] px-4 py-8 overflow-auto`}>
                        <div className='flex flex-wrap gap-10 w-full h-full justify-around items-center max-[900px]:flex-col max-[900px]:h-fit '>
                            <div className="flex flex-wrap gap-10 w-full justify-around items-center max-[900px]:flex-col max-[900px]:h-fit">
                                {rest.map((item, index) => (
                                    <Card
                                        key={`card-${index}`}
                                        raised
                                        onClick={() => navigate(item.dataInfo.Path)}
                                        className="!rounded-2xl !w-full !cursor-pointer relative z-10"
                                        sx={{ maxWidth: 450 }}
                                    >
                                        <ButtonInternet item={item} Wifi Activate={user?.Maintenance}/>
                                        <ButtonInternet item={item} ChangeMade Activate={user?.Maintenance}/>
                                        <CardMedia sx={{ height: 250 }}>
                                            <img
                                                src={item.dataInfo.Image}
                                                alt={item.dataInfo.Name}
                                                onError={(e) => {
                                                    console.warn("Error cargando imagen remota, usando local...");
                                                    e.currentTarget.src = "/img/Letrero.png"; // TU IMAGEN LOCAL EN PUBLIC
                                                }}
                                                style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    objectFit: "cover",
                                                    borderRadius: "inherit"
                                                }}
                                            />
                                        </CardMedia>
                                        <CardContent className="text-center !p-2">
                                            <span className="font-Poppins font-bold text-[2rem] text-black uppercase">
                                                {item.dataInfo.Name}
                                            </span>
                                        </CardContent>
                                    </Card>
                                ))}
                            </div>
                            {lastTwo.length > 0 && (
                                <div className="flex flex-wrap gap-10 w-full pb-4 justify-around items-center max-[900px]:flex-col max-[900px]:h-fit">
                                    {lastTwo.map((item, index) => (
                                        <Card
                                            key={`card-last-${index}`}
                                            raised
                                            onClick={() => navigate(item.dataInfo.Path)}
                                            className="!rounded-2xl !w-full !cursor-pointer relative"
                                            sx={{ maxWidth: 450 }}
                                        >
                                            
                                            <ButtonInternet item={item} Wifi Activate={user?.Maintenance}/>
                                            <ButtonInternet item={item} ChangeMade Activate={user?.Maintenance}/>
                                            <CardMedia sx={{ height: 250 }}>
                                                <img
                                                    src={item.dataInfo.Image}
                                                    alt={item.dataInfo.Name}
                                                    onError={(e) => {
                                                        console.warn("Error cargando imagen remota, usando local...");
                                                        e.currentTarget.src = "/img/Letrero.png"; // TU IMAGEN LOCAL EN PUBLIC
                                                    }}
                                                    style={{
                                                        width: "100%",
                                                        height: "100%",
                                                        objectFit: "cover",
                                                        borderRadius: "inherit"
                                                    }}
                                                />
                                            </CardMedia>
                                            <CardContent className="text-center !p-2">
                                                <span className="font-Poppins font-bold text-[2rem] text-black uppercase">
                                                    {item.dataInfo.Name}
                                                </span>
                                            </CardContent>
                                        </Card>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </>
            ) : (
                <div className={`w-full h-full flex flex-col gap-8 items-center bg-[#f9f9f9] px-4 py-8 overflow-auto`}>
                    <div className='flex flex-wrap gap-5 w-full h-full justify-around items-center max-[900px]:flex-col max-[900px]:h-fit '>
                        <Card className='!rounded-2xl !w-full !cursor-wait' raised sx={{ maxWidth: 450 }}>
                            <Skeleton variant="rectangular" width="100%" height={250} />
                            <CardContent className='!flex !p-2 !justify-center'>
                                <Skeleton className='!text-center' variant="text" width="80%" height={40} />
                            </CardContent>
                        </Card>
                    </div>
                </div>
            )
            }
        </>
    );
}

export default Paneles